(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Lr-Reviewss"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-lr-review]').forEach(root => {
      if (root.dataset.lrReviewReady === 'true') return;
      root.dataset.lrReviewReady = 'true';
      const viewport = root.querySelector('[data-lr-review-viewport]');
      const track = root.querySelector('.lr-review__track');
      const cards = [...root.querySelectorAll('.lr-review-card')];
      const dots = [...root.querySelectorAll('[data-lr-review-dots] span')];
      const previous = root.querySelector('[data-lr-review-prev]');
      const next = root.querySelector('[data-lr-review-next]');
      let current = 0;
      const visibleCards = () => window.innerWidth < 750 ? 1 : window.innerWidth < 990 ? 3 : window.innerWidth < 1200 ? 4 : 5;
      const maximum = () => Math.max(0, cards.length - visibleCards());
      const update = () => {
        if (!cards.length || !track) return;
        if (window.innerWidth >= 750) {
          current = Math.min(current, maximum());
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          track.style.transform = `translate3d(-${current * (cards[0].getBoundingClientRect().width + gap)}px,0,0)`;
          if (previous) previous.disabled = current === 0;
          if (next) next.disabled = current >= maximum();
        } else {
          track.style.transform = '';
        }
      };
      const updateDots = () => {
        if (window.innerWidth >= 750 || !viewport || !dots.length) return;
        const center = viewport.getBoundingClientRect().left + viewport.clientWidth / 2;
        let nearest = 0, distance = Infinity;
        cards.forEach((card, index) => { const value = Math.abs(card.getBoundingClientRect().left + card.clientWidth / 2 - center); if (value < distance) { nearest = index; distance = value; } });
        current = nearest;
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === nearest));
      };
      const move = direction => {
        if (window.innerWidth < 750 && viewport) { current = (current + direction + cards.length) % cards.length; viewport.scrollTo({ left: Math.max(0, cards[current].offsetLeft - 16), behavior: 'smooth' }); return; }
        current = Math.max(0, Math.min(maximum(), current + direction * visibleCards())); update();
      };
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      viewport?.addEventListener('scroll', () => requestAnimationFrame(updateDots), { passive: true });
      window.addEventListener('resize', () => { update(); updateDots(); });
      update(); updateDots();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
